import { api } from 'api/client';

export const markReadNotification = (ids: string[]) =>
  api.patch('/notification', { ids });
